var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14018 11.585H3.35916C2.80437 11.5805 2.27046 11.7965 1.87491 12.1855C1.47936 12.5746 1.25458 13.1048 1.25 13.6595V21.5109C1.26025 22.6657 2.20438 23.5938 3.35916 23.584H7.14018C7.69493 23.5887 8.22889 23.3727 8.62448 22.9837C9.02003 22.5947 9.2448 22.0645 9.24934 21.5095V13.6595C9.2448 13.1048 9.02003 12.5746 8.62448 12.1855C8.22889 11.7965 7.69493 11.5805 7.14018 11.585Z",
    stroke: "#ECECEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14018 1.2508H3.35916C2.22759 1.21943 1.28412 2.10986 1.25 3.24131V4.5932C1.28412 5.72469 2.22759 6.61511 3.35916 6.5837H7.14018C8.27167 6.61511 9.21522 5.72469 9.24934 4.5932V3.24131C9.21522 2.10986 8.27167 1.21943 7.14018 1.2508Z",
    stroke: "#ECECEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3587 13.2501H20.1384C20.6934 13.2551 21.2276 13.0392 21.6234 12.6502C22.0193 12.261 22.2443 11.7306 22.2489 11.1756V3.32554C22.2443 2.77076 22.0195 2.24051 21.624 1.85146C21.2284 1.46245 20.6944 1.24647 20.1397 1.25105H16.3587C15.8039 1.24647 15.27 1.46245 14.8744 1.85146C14.4788 2.24051 14.2541 2.77076 14.2495 3.32554V11.1756C14.2541 11.7304 14.4788 12.2606 14.8744 12.6497C15.27 13.0387 15.8039 13.2546 16.3587 13.2501Z",
    stroke: "#ECECEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3587 23.5837H20.1384C21.2704 23.6158 22.2147 22.7252 22.2489 21.5932V20.2413C22.2147 19.1098 21.2712 18.2195 20.1397 18.2508H16.3587C15.2272 18.2195 14.2836 19.1098 14.2495 20.2413V21.5919C14.2828 22.7239 15.2266 23.615 16.3587 23.5837Z",
    stroke: "#ECECEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.4110ff6f7d5158a6e10af6acffd76195.svg";
export { ForwardRef as ReactComponent };